import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n/'

export const footerStringProps = () => ({
  getToKnowUs: i18n.t(i18nKeys.footer__getToKnowUs),
  aboutUs: i18n.t(i18nKeys.footer__aboutUs),
  careers: i18n.t(i18nKeys.footer__careers),
  blog: i18n.t(i18nKeys.footer__blog),
  stories: i18n.t(i18nKeys.footer__stories),
  linkedIn: i18n.t(i18nKeys.footer__linkedIn),
  glassdoor: i18n.t(i18nKeys.footer__glassdoor),
  accessibility: i18n.t(i18nKeys.footer__accessibility),
  letUsHelpYou: i18n.t(i18nKeys.footer__letUsHelpYou),
  accountDetails: i18n.t(i18nKeys.footer__accountDetails),
  orderHistory: i18n.t(i18nKeys.footer__orderHistory),
  help: i18n.t(i18nKeys.footer__help),
  doingBusiness: i18n.t(i18nKeys.footer__doingBusiness),
  becomeADasher: i18n.t(i18nKeys.footer__becomeADasher),
  beAPartnerRestaurant: i18n.t(i18nKeys.footer__partnerRestaurant),
  getDashersForDeliveries: i18n.t(i18nKeys.footer__dashersForDeliveries),
  drivingOpportunities: i18n.t(i18nKeys.footer__drivingOpportunities),
  deliveryHours: i18n.t(i18nKeys.footer__deliveryHours),
  everyDayHours: i18n.t(i18nKeys.footer__everyDayHours),
  termsOfService: i18n.t(i18nKeys.footer__termsOfService),
  privacy: i18n.t(i18nKeys.footer__privacy),
  deliveryLocations: i18n.t(i18nKeys.footer__deliveryLocations),
  getTheApp: i18n.t(i18nKeys.footer__getTheApp),
  appStore: i18n.t(i18nKeys.footer__appStore),
  googlePlay: i18n.t(i18nKeys.footer__googlePlay),
  ccpaDoNotSell: i18n.t(i18nKeys.footer__doNotSell),
  allRightsReserved: i18n.t(i18nKeys.footer__allRightsReserved),
})
